module.exports = __webpack_public_path__ + "static/media/waterbath-closed.5a19f83f.svg";